import { FC } from "react";
import { Box } from "@smile2impress/components";

import { Typeform } from "components/Typeform";
import { TypeformComplainFormular } from "components/Typeform/constants";

export const ComplainsFormularLayout: FC = () => {
    return (
        <Box h="100svh">
            <Typeform typeformIds={TypeformComplainFormular} />
        </Box>
    );
};
